import mitt from "mitt";

type GifPlaybackEvent = {
  id: string;
  duration: number;
};

type MainBusEvents = {
  gif_view: string;
  gif_playback: GifPlaybackEvent;
  toggle_fullscreen: { id?: string } | undefined;
  add_streamate_camera: number;
  clear_streamate_cameras: void;
  close_search: void;
};

export const bus = mitt<MainBusEvents>();
